import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafeHtmlPipe, TranslatePipe } from '@app/shared/pipes';
import { NgClass } from '@angular/common';
import { IconName } from '@app/shared/utils/icon/icons';
import { IconComponent } from '@app/shared/utils/icon/icon.component';
import { DetectMobile } from '@app/shared/utils';
import { StepperItem } from '@app/core/services/tracking/types/interfaces';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslatePipe, SafeHtmlPipe, NgClass],
})
export class StepperComponent {
  @Input() items: StepperItem[];

  public IconName = IconName;
  public readonly DetectMobile = DetectMobile;

  public isItemChecked(index: number): boolean {
    const activeItemIndex = this.items.findIndex((i) => i.isActive);

    if (activeItemIndex !== -1) {
      return index < activeItemIndex;
    }
    return false;
  }
}
